import { render, staticRenderFns } from "./RoleCapabilitiesCard.vue?vue&type=template&id=22e574b0&scoped=true&"
import script from "./RoleCapabilitiesCard.vue?vue&type=script&lang=js&"
export * from "./RoleCapabilitiesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e574b0",
  null
  
)

export default component.exports